import handleGroupingSelection from '../handlers/handleGroupingSelection';
const install = () => {
  window.addEventListener('molten.grouping.selection', handleGroupingSelection);
};
export default {
  install
};